import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';


import {ActionService} from "@/services/action.service";

import {Logger} from '@/util/logger';

import {Router} from '@angular/router';
import {ShowLeafletControlbar} from "@/components/leaflet/actions/show.leaflet.controlbar";
import {HideLeafletControlbar} from "@/components/leaflet/actions/hide.leaflet.controlbar";
import {ActionType} from "@/models/action.type";

@Component({
  standalone: false,
  selector: 'leaflet-controls',
  template: `
    <div [class.enabled]="enabled" class="leaflet-controls-inner">

      <div class="leaflet-controls-button" pTooltip="Reset View" tooltipPosition="right" tooltipZIndex="20000">
        <img (click)="reset()" src="/assets/images/reset-72.png">
      </div>

      <div class="leaflet-button-separator"></div>

      <div class="leaflet-controls-button"  pTooltip="Zoom In" tooltipPosition="right" tooltipZIndex="20000">
        <img (click)="zoomIn()" src="/assets/images/zoom-in-72.png">
      </div>

      <div class="leaflet-button-separator"></div>

      <div class="leaflet-controls-button"  pTooltip="Zoom Out" tooltipPosition="right" tooltipZIndex="20000">
        <img (click)="zoomOut()"  src="/assets/images/zoom-out-72.png">
      </div>

      <div class="leaflet-controls-button" *ngIf="!isMiniMap()" pTooltip="Toggle Panorama Selector" tooltipPosition="right" tooltipZIndex="20000">
        <img (click)="toggleFilter()"  src="/assets/images/filter-black-72.png">
      </div>

    </div>
  `
})

/**
 *
 * @class LeafletControls
 *
 * @brief our custom action button bar for the leaflet map
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class LeafletControls implements OnInit, OnDestroy, AfterViewInit {

  /** hide/show the controls for the map */
  public enabled: boolean = false;

  @Input() mode                                   = 'overwatch';

  /**
   * standard constructor
   *
   * @param router  in case we need to redirect the page
   * @param actions the GUI actions we can invoke
   */
  constructor(
    private router: Router,
    private actions: ActionService
  ) {

    /* register actions to hide/show self */

    this.actions.add(new ShowLeafletControlbar(this));
    this.actions.add(new HideLeafletControlbar(this));
  }


  /** check if we are in minimap mode */
  isMiniMap(): boolean {

    let lc: LeafletControls = this;

    return lc.mode != "overwatch";
  }


  /** show the controls */
  showControls() {

    this.enabled = true;
  }

  /** hide the controls */
  hideControls() {

    this.enabled = false;
  }

  /* on creation subscribe to the alert service so we get updates when alerts happen from anywhere */
  ngOnInit() {

    Logger.debug('[LeafletControls] init...');

  }

  ngAfterViewInit() {

    Logger.debug('[LeafletControls] after view init...');

    if (this.isMiniMap()) {

      setTimeout( () => {

        this.enabled = true;

      }, 50);

    }
  }

  /* clean up at the end */
  ngOnDestroy() {

    Logger.debug('[LeafletControls] destroy...');
  }

  reset() {

    this.actions.action(ActionType.LEAFLET_RESET).execute();
  }

  zoomIn() {

    this.actions.action(ActionType.LEAFLET_ZOOM_IN).execute();
  }

  zoomOut() {

    this.actions.action(ActionType.LEAFLET_ZOOM_OUT).execute();
  }

  toggleFilter() {

    setTimeout( () => {

      this.actions.action(ActionType.PANO_SELECTOR_TOGGLE).execute();

      }, 50);
  }
}
